<template>
  <nav class="navbar">
    <div class="logo">
      <img src="@/assets/image/logo.png" alt="Scrub Point Logo" />
    </div>

    <ul class="nav-links">
      <li><a href="#home">{{ $t("nav.home") }}</a></li>
      <li><a href="#about">{{ $t("nav.about") }}</a></li>
      <li><a href="#values">{{ $t("nav.values") }}</a></li>
      <li><a href="#features">{{ $t("nav.features") }}</a></li>
      <li><a href="#services">{{ $t("nav.services") }}</a></li>
      <li><a href="#contact">{{ $t("nav.contact") }}</a></li>
    </ul>

    <button class="lang-btn" @click="switchLanguage">
      {{ currentLang === 'ar' ? 'EN' : 'ع' }}
    </button>
  </nav>
</template>

<script>
export default {
  name: "nav-bar",
  data() {
    return {
      currentLang: localStorage.getItem("lang") || this.$i18n.locale,
    };
  },
  created() {
    // If there's a saved language, apply it and notify parent to adjust direction
    const saved = localStorage.getItem("lang");
    if (saved) {
      this.$i18n.locale = saved;
      this.$emit("change-lang", saved);
    }
  },
  methods: {
    switchLanguage() {
      this.currentLang = this.currentLang === "ar" ? "en" : "ar";
      localStorage.setItem("lang", this.currentLang);
      this.$emit("change-lang", this.currentLang);
    },
  },
};
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #ffffffdd;
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 60px;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.logo img:hover {
  transform: scale(1.05);
}

.nav-links {
  display: flex;
  gap: 25px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-links li a {
  text-decoration: none;
  color: #222;
  font-weight: 500;
  transition: color 0.3s, transform 0.2s;
}

.nav-links li a:hover {
  color: #00bcd4;
  transform: scale(1.1);
}

.lang-btn {
  background: #00bcd4;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  transition: background 0.3s;
}

.lang-btn:hover {
  background: #009fb5;
}

@media (max-width: 768px) {
  .navbar {
    flex-direction: column;
    padding: 10px 20px;
  }
  .nav-links {
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
  }
}
</style>